import React from 'react'
import {
  AddNewOpportunity,
  AddOpportunityFromDuplicateAlert,
  AddOpportunityFromExistingOpportunity,
  AddOpportunityFromLead,
} from './Wrappers'

type Props = {
  id: string | null
  source: string
}

export function NewAddOpportunityRouter(props: Props) {
  const { id, source } = props

  const idNumber = id ? parseInt(id) : undefined
  switch (source) {
    case 'new':
      return <AddNewOpportunity />
    case 'lead':
      return idNumber ? <AddOpportunityFromLead leadId={idNumber} /> : null
    case 'opportunity':
      return idNumber ? (
        <AddOpportunityFromExistingOpportunity opportunityId={idNumber} />
      ) : null
    case 'duplicate':
      return <AddOpportunityFromDuplicateAlert />
    default:
      return null
  }
}
